export const SEARCH_PAGE = 'search.index'
export const DETAILS_PAGE = 'details.index'

export const PRIVACY = 'info.privacy'
export const TERMS = 'info.terms'
